import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 flex flex-col items-center justify-center border-b border-brown/10 mb-8" data-id="element-62">
      <div className="flex items-center gap-2 text-forest mb-1" data-id="element-63">
        <BookOpen size={24} data-id="element-64" />
        <h1 className="font-handwriting text-3xl font-bold tracking-wide" data-id="element-65">
          Napftagebuch
        </h1>
      </div>
      <p className="font-serif text-sm text-brown/80 italic" data-id="element-66">
        Ehrliche Geschichten aus dem Hundealltag
      </p>
    </header>;
}